<template>
    <div>
        <header-message class="msg0 mt-5 mb-2">The windshield angle you entered is outside of tolerance.</header-message>

        <header-message class="msg1 mt-2 mb-2">Please Contact Auggie Support at</header-message>

        <header-message class="msg2 mt-2 mb-4">904 990-1122</header-message>

        <div class="buttonrow">
            <button-button class="btn btn-primary" type="submit" @click.prevent="okClicked">OK</button-button>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .msg2 {
        text-decoration: underline;
    }
    .msg1, .msg2 {
        color: orange;
        font-style: normal;
    }
</style>

<script lang="ts">
import { defineComponent } from "vue";

import PageBase from "@/shared/components/common/PageBase";
import HeaderMessage from "@/components/HeaderMessage.vue";
import { CalibrationEventSupport } from "@/support/CalibrationEvent";
import { DeviceStatusDto } from "@/shared/models/DeviceStatusDto";
import { SignalR } from "@/support/SignalR";
import { CalibrationEvent } from "@/shared/enums/CalibrationEvent";

export default defineComponent({
    name: "CalibrationContactSupportWindshieldAngle",
    mixins: [PageBase],
    components: {
        HeaderMessage,
    },
    methods: {
        okClicked(): void {
            CalibrationEventSupport.sendEventStatus({
                Page: "CalibrationContactSupportWindshieldAngle",
            } as DeviceStatusDto);
            CalibrationEventSupport.sendEventCalibrationRestart(CalibrationEvent.RestartCalibration, null);
        },
        getCurrentStatusForListeners(): void {
            CalibrationEventSupport.sendEventStatus({
                Page: "CalibrationContactSupportWindshieldAngle",
            } as DeviceStatusDto);
        }
    },
    mounted(): void {
        SignalR.onGetCurrentStatusForListeners = this.getCurrentStatusForListeners;
        SignalR.onContactSupportWindshieldAngleAcknowledgeByCompanion = this.okClicked;
        this.getCurrentStatusForListeners();
    },
    unmounted(): void {
        SignalR.onGetCurrentStatusForListeners = null;
        SignalR.onContactSupportWindshieldAngleAcknowledgeByCompanion = null;
    }
});
</script>
